import K_Accordion from "../templates/K_Accordion";
import { AccordionPanel } from "./accordionPanel";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface AccordionOptions extends ComponentOptions {
    components?: AccordionPanel[];
    expandMode?: "single" | "multiple";
}

export class Accordion extends TemplateComponent {

    options: AccordionOptions;
    content: {
        components: AccordionPanel[];
    };
    private expandMode: "single" | "multiple";

    constructor(options: AccordionOptions) {
        super(K_Accordion, options);

        this.content = {
            components: options.components || []
        };
    }

    preRender() {
        this.expandMode = this.options.expandMode === undefined
            ? "multiple"
            : this.options.expandMode;
    }

    create() {
        var me = this;

        $(`#${me.id}`).kendoPanelBar({
            expandMode: me.expandMode
        });

        // opens the first accordion panel
        $(`#${me.id}`).find("li:nth-child(1) .k-link").click();
    }

}
